export const CREATIVE_MEDIA_TYPES = {
  video: "video",
  display: "display"
};

export const CREATIVE_TYPES = {
  offsite: "offsite",
  onsite: "onsite",
  instoreDOOH: "instore_dooh",
  brandLift: "brand_lift",
  brandLiftVideo: "brand_lift_video", // This is purely a frontend type to differentiate brand lift videos in the UI, it will be created as a regular brand lift creative in the backend
};
